import src from "IMAGE";
export default { src, width: 46, height: 53, blurWidth: 0, blurHeight: 0};
